import React, { Component } from 'react'
import moment from 'moment'

const months = [
  'January',
  'February',
  'March',
  'April',
  'May',
  'June',
  'July',
  'August',
  'September',
  'October',
  'November',
  'December',
]

const collectDate = (month, day, year) => new Date(year, month, day)

const dateStyle = { display: 'flex', minWidth: 280 }

const DEFAULT_MAX_YEAR = 2009
const DEFAULT_MIN_YEAR = 1919

export class DatePicker extends Component {
  state = {
    month: '',
    day: 1,
    year: DEFAULT_MIN_YEAR,
    minYear: DEFAULT_MIN_YEAR,
    maxYear: DEFAULT_MAX_YEAR,
    isValidDate: true,
  }

  componentDidMount() {
    const { value, max, min } = this.props

    const date = value ? moment(value) : ''
    const month = date ? date.format('MMMM') : ''
    const day = date ? date.format('DD') : ''
    const year = date ? date.format('YYYY') : ''
    const maxYear = max || DEFAULT_MAX_YEAR
    const minYear = min || DEFAULT_MIN_YEAR
    this.setState({ month, day, year, maxYear, minYear })
  }

  handleInputChange = (e) => this.setState({ [e.target.name]: e.target.value })

  handleDateChange = () => {
    const { state, props } = this
    const { month, day, year } = state

    let m = (months.indexOf(month) + 1).toString()
    if (m.length === 1) {
      m = `0${m}`
    }
    let d = day.toString()
    if (d.length === 1) {
      d = `0${d}`
    }
    let isValidDate = true
    const yearIsValid = year >= state.minYear && year <= state.maxYear

    if (!moment(`${year}/${m}/${d}`, 'YYYY/MM/DD', true).isValid() || !yearIsValid) {
      this.setState({ isValidDate: false })
    } else {
      this.setState({ isValidDate: true })
      const date = moment(collectDate(months.indexOf(month), d, year)).format('YYYY-MM-DD')
      props.onChange(date)
      this.setState({ isValidDate })
    }
  }

  onMonthChange = (e) => this.setState({ month: e.target.value }, () => this.handleDateChange())

  onDayChange = (e) => this.setState({ day: e.target.value }, () => this.handleDateChange())

  onYearChange = (e) => this.setState({ year: e.target.value }, () => this.handleDateChange())

  stopPropagation = (e) => {
    e.stopPropagation()
  }

  render() {
    const { month, day, year, isValidDate, maxYear, minYear } = this.state
    return (
      <div style={{ ...dateStyle }} className={`${isValidDate ? '' : this.props.validation ? 'has-error' : ''}`}>
        <select
          style={{ minWidth: 100 }}
          className={'form-control'}
          value={month}
          placeholder='select'
          onChange={this.onMonthChange}
        >
          <option value='' disabled='disabled'>
            Month
          </option>
          {months.map((m) => (
            <option key={m} value={m}>
              {m}
            </option>
          ))}
        </select>
        <input
          className={'form-control'}
          value={day}
          placeholder='Day'
          type='number'
          min='1'
          max='31'
          onChange={this.onDayChange}
          onKeyDown={this.stopPropagation}
        />
        <input
          className={'form-control'}
          value={year}
          placeholder='Year'
          type='number'
          min={minYear}
          max={maxYear}
          onChange={this.onYearChange}
          onKeyDown={this.stopPropagation}
        />
      </div>
    )
  }
}
